import Vue from 'vue'
import Router from 'vue-router'
import index from '../views/index'
import courseList from '../views/courseList'
import course from '../views/course'
import news from '../views/news'
import policy from '../views/policy'
import PolicyDetail from '../views/PolicyDetail'
import school from '../views/school'
import skill from '../views/skill'
import teacher from '../views/teacher'
import study from '../views/mySpace/profile'
import trainenter from '../views/trainEnter'
import Login from '../views/Login'
import SchoolClasses from '../views/schoolClasses'
import ClassDetail from '../views/classDetail'
import StudentLogin from '../views/student/StudentLogin'
import Sturegister from '../views/student/Sturegister'

Vue.use(Router);
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      beforeEnter(to, from, next) {
        next();
      },
      meta:{requireAuth:true,title:''}
    }, {
      path: '/courseList/:id',
      name: 'courseList',
      component: courseList,
      beforeEnter(to, from, next) {
        next();
      },
      meta:{requireAuth:true,title:'课程列表'}
    }, {
      path: '/courseList/:id/:subId',
      name: 'subCourseList',
      component: courseList,
      beforeEnter(to, from, next) {
        next();
      },
      meta:{requireAuth:true,title:'课程列表'}
    }, {
      path: '/course/:id',
      name: 'course',
      component: course,
      beforeEnter(to, from, next) {
        next();
      },
      meta:{requireAuth:true,title:'课程详情'}
    }, {
      path: '/courseSearch',
      name: 'search',
      component: courseList,
      beforeEnter(to, from, next) {
        next();
      },
      meta:{requireAuth:true,title:'课程详情'}
    }, {
      path: '/news',
      name: 'news',
      component: news,
      beforeEnter(to, from, next) {
        next();
      },
      meta:{requireAuth:true,title:'行业资讯'}
    }, {
      path: '/policy',
      name: 'policy',
      component: policy,
      beforeEnter(to, from, next) {
        next();
      },
      meta:{requireAuth:true,title:'政策法规'}
    }, 
    {
      path: '/policy/:id',
      name: 'PolicyDetail',
      component: PolicyDetail,
      beforeEnter(to, from, next) {
        next();
      },
      meta:{requireAuth:true,title:'文章详情'}
    },
    {
      path: '/school',
      name: 'school',
      component: school,
      beforeEnter(to, from, next) {
        next();
      },
      meta:{requireAuth:true,title:'培训机构'}
    }, {
      path: '/school/:id',
      name: 'SchoolClasses',
      component: SchoolClasses,
      beforeEnter(to, from, next) {
        next();
      },
      meta:{requireAuth:true,title:'培训机构'}
    },
    {
      path: '/class/:id',
      name: 'class',
      component: ClassDetail,
      beforeEnter(to, from, next) {
        next();
      },
      meta:{requireAuth:true,title:'班级详情'}
    }, {
      path: '/skill',
      name: 'skill',
      component: skill,
      beforeEnter(to, from, next) {
        next();
      },
      meta:{requireAuth:true,title:'技能培训'}
    }, {
      path: '/teacher',
      name: 'teacher',
      component: teacher,
      beforeEnter(to, from, next) {
        next();
      },
      meta:{requireAuth:true,title:'技能大师'}
    }, {
      path: '/study',
      name: 'study',
      component: study,
      beforeEnter(to, from, next) {
        next();
      },
      meta:{requireAuth:true,title:'我的学习'}
    }, {
      path: '/trainenter',
      name: 'trainenter',
      component: trainenter,
      beforeEnter(to, from, next) {
        next();
      },
      meta:{requireAuth:true,title:'培训机构入驻'}
    }, {
      path: '/login',
      name: 'Login',
      component: Login,
      beforeEnter(to, from, next) {
        next();
      },
      meta:{requireAuth:true,title:'培训机构登录'}
    }, {
      path: '/student/login',
      name: 'StudentLogin',
      component: StudentLogin,
      beforeEnter(to, from, next) {
        next();
      },
      meta:{requireAuth:true,title:'学员登录'}
    }, {
      path: '/student/register',
      name: 'Sturegister',
      component: Sturegister,
      beforeEnter(to, from, next) {
        next();
      },
      meta:{requireAuth:true,title:'学员注册'}
    }
  ]
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js